import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Login.component.scss";

const LoginComponent = ({ clickLogin, clickGoogle, clickRecuperar }) => {
  const [usuario, setUsuario] = useState({
    Usuario: "",
    Clave: "",
  });

  const handleInput = (e) => {
    setUsuario({
      ...usuario,
      [e.target.name]: e.target.value,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // clickLogin(usuario.Usuario, usuario.Clave);
    }
  };

  const handleClickLogin = () => {
    // props.clickLogin(usuario.Usuario, usuario.Clave);
    clickLogin(usuario.Usuario, usuario.Clave);
  };

  const handleClickGoogle = () => {
    clickGoogle();
  };

  const handleClickRecuperar = () =>{
    clickRecuperar(true);
  }

  return (
    <>
      <div className="row mt-5">
        <div className="col-12">
          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>
                Correo <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="Usuario"
                type="text"
                placeholder="Correo"
                onChange={handleInput}
                onKeyDown={handleKeyDown}
              />
            </Form.Group>
            <Form.Group controlId="formBasicPassword">
              <Form.Label>
                Contraseña <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="Clave"
                type="password"
                placeholder="Contraseña"
                onChange={handleInput}
                onKeyDown={handleKeyDown}
              />
            </Form.Group>
            <Form.Group controlId="formBasicCheckbox">
              <Form.Text className="h6 font-weight-bold text-danger">
                Datos necesarios
              </Form.Text>
            </Form.Group>
          </Form>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12 col-lg-6">
          <Button
            variant="secondary"
            type="button"
            block="true"
            onClick={handleClickLogin}
          >
            Iniciar Sesión
          </Button>
        </div>
        <div className="col-12 col-lg-6">
          <Button variant="link" type="button" block="true" onClick={handleClickRecuperar}>
            Olvidaste tu contraseña?
          </Button>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12">
          <Button
            variant="google"
            type="button"
            block="true"
            onClick={handleClickGoogle}
          >
            <FontAwesomeIcon icon={["fab", "google"]} pull="left" size="lg" />
            Ingresar con google
          </Button>
        </div>
      </div>
    </>
  );
};

export default LoginComponent;
